module.exports = __webpack_public_path__ + "img/code-js-lg.cad8084a.webp";